import { IGUIProps } from "../GUI";

export default function ChevronRight(props:IGUIProps){
    const className = props.className ? {className:props.className} : {}
    return <svg {...className} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#78A75A"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
}